<script setup lang="ts">
const config = useRuntimeConfig();
const appName = (config.public.clientConfig as any)?.appName ?? 'SpreadIt';
</script>

<template>
  <NuxtLink to="/" class="flex items-center gap-2.5 select-none">
    <img src="/company_logo.svg" :alt="appName" class="h-8 w-8 object-contain" />
    <span class="font-semibold text-base tracking-tight text-gray-800 dark:text-gray-100">{{ appName }}</span>
  </NuxtLink>
</template>
